<template>
  <div :class="$style.wrapper">
    <div :class="$style.top">
      <span>
        Чатик
      </span>
      <span>
        8 участников
      </span>
    </div>
    <div :class="$style.inner" ref="inner">
      <Message
        v-for="(item, index) in proxyMessages"
        :key="index"
        v-bind="item"
      >
        <span v-html="item.message"></span>
      </Message>
    </div>
  </div>
</template>
<script>
import users from '../../users'

import Message from './components/Message/Message.vue'

const [ARSEN, ANYA, TEMA, SONYA, SASHA,, SKB, KSU] = users

const messages = [
  {
    from: SKB,
    date: '7:45',
    message: 'Запятыня, Саша, не забудьте форму взять, сегодня в футбол пойдём!',
  },
  {
    from: SASHA,
    date: '7:50',
    message: 'О, спасибо, что напомнил, осталось только уместить её в рюкзак…',
  },
  {
    from: SKB,
    date: '7:51',
    message: 'А что ты ещё собрался тащить?? Сегодня же только литература да математика.',
  },
  {
    from: SASHA,
    date: '7:51',
    message: 'Войну и мир! Хочу показать Наталье Владимировне, какие у меня необычные иллюстрации в книге!',
    like: KSU,
  },
  {
    from: SKB,
    date: '7:51',
    message: `<img src="${require('./assets/hmm.png')}" alt="">`,
    sticker: true,
  },
  {
    from: TEMA,
    date: '8:30',
    message: 'Ой, Соня, Аня, я проспал, идите без меня.',
  },
  {
    from: SONYA,
    date: '8:31',
    message: 'Ок.',
  },
  {
    from: ANYA,
    date: '8:32',
    message: 'Ты к музыкальной переменке-то успеешь?',
  },
  {
    from: TEMA,
    date: '8:32',
    message: 'Постараюсь, а что вы будете петь?',
  },
  {
    from: ARSEN,
    date: '8:32',
    message: 'Попробуй угадать песню (это Монеточка): 🔥🔥',
  },
  {
    from: TEMA,
    date: '8:42',
    message: 'Хм… Так непонятно, ну скоро узнаю) до встречи!',
  },
]

export default {
  name: 'Chat',
  data: () => ({
    users,
    proxyMessages: [],
    interacted: false,
  }),
  components: {
    Message,
  },
  methods: {
    doResize() {
      const { $refs: { inner } } = this

      if (!this.interacted) {
        inner.scrollTop = inner.scrollHeight
      }

      this.watcher = requestAnimationFrame(this.doResize)
    },
    makeInteracted() {
      this.interacted = true
    },
  },
  mounted() {
    const sound = new Audio(require('./assets/vk-sound.mp3'))
    messages.forEach((message, index) => {
      setTimeout(() => {
        this.proxyMessages.push(message)
        sound.currentTime = 0
        sound.volume = 0.2
        sound.play()
      }, index * 400 + 200 + Math.random() * 300)
    })

    this.interacted = false
    this.watcher = requestAnimationFrame(this.doResize)

    this.$refs.inner.addEventListener('mouseover', this.makeInteracted, { once: true })
    this.$refs.inner.addEventListener('wheel', this.makeInteracted, { once: true })
    this.$refs.inner.addEventListener('touchstart', this.makeInteracted, { once: true })
  },
  beforeDestroy() {
    cancelAnimationFrame(this.watcher)
  },
}
</script>
<style lang="scss" module>
@import './Chat.scss';
</style>
